'use client';

import React from 'react';
import round from 'lodash/round';
import maxBy from 'lodash/maxBy';
import last from 'lodash/last';
import TopSection from '../TopSection';
import SvgLocation from '../SvgLocation';
import SvgBuilding from '../SvgBuilding';
import SvgMoney from '../SvgMoney';
import SvgBusiness from '../SvgBusiness';
import { WORK_EXPERIENCE_MAP } from '@/constants/job-title';
import { JOB_RANKING_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { JobTitleType } from '@/types/job-title';

const Top = (props: {
  displayName: string;
  componentOfName: string;
  avgSalary: number;
  currentCount: number;
  currentCountByExperience: JobTitleType['current_count_group_by_experience'];
  newJobDetailsByMonth: JobTitleType['job_open_details']['new_job_details']['by_month'];
  cityStats: JobTitleType['job_open_details']['city_stats'];
  seoContent: Record<string, any>;
  salaryRank: JobTitleType['salary_rank'];
  location?: JobTitleType['location'];
}) => {
  const {
    displayName,
    componentOfName,
    avgSalary,
    currentCountByExperience,
    currentCount,
    seoContent,
    newJobDetailsByMonth,
    cityStats,
    salaryRank,
    location,
  } = props;

  const maxExperience = maxBy(currentCountByExperience, 'value');

  return (
    <TopSection
      navList={[
        {
          name: salaryRank.l1_name,
          href: `${JOB_RANKING_PAGE_ROUTER_PATH}${
            location ? `${location.pinyin}_` : ''
          }${salaryRank.l1_id}/`,
        },
        {
          name: (location ? location.name.replace('市', '') : '') + displayName,
        },
      ]}
      title={displayName}
      subTitle={seoContent?.['职位介绍']}
      subTitleClassName="text-base"
      cardList={[
        {
          title: '热招城市',
          content: (cityStats?.by_current_count?.[0]?.name || '').replace(
            '市',
            '',
          ),
          subContent: `开放岗位 ${cityStats?.by_current_count?.[0]?.count || 0}+`,
          icon: <SvgLocation />,
        },
        {
          title: '市场偏好',
          content: maxExperience
            ? `${WORK_EXPERIENCE_MAP[maxExperience.name]}`
            : '',
          subContent: maxExperience
            ? `占开放岗位约 ${round((maxExperience.value / currentCount) * 100, 1)}%，需求最高`
            : '',
          icon: <SvgBuilding />,
        },
        {
          title: '平均月薪',
          content: `¥${round(avgSalary, -2)}`,
          icon: <SvgMoney />,
        },
        {
          title: '开放岗位',
          content: `${currentCount}`,
          icon: <SvgBusiness />,
        },
      ]}
      tags={[
        componentOfName,
        (last(newJobDetailsByMonth || [])?.value || 0) > 200
          ? '需求量大'
          : '需求量小',
      ]}
      subTags={seoContent?.['职位页标签'] || []}
    />
  );
};

export default Top;
